import { render } from "./BranchSelection.vue?vue&type=template&id=13d86748&scoped=true"
import script from "./BranchSelection.vue?vue&type=script&lang=js"
export * from "./BranchSelection.vue?vue&type=script&lang=js"

import "./BranchSelection.vue?vue&type=style&index=0&id=13d86748&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d86748"]])

export default __exports__